export default __webpack_public_path__ + "static/media/reseller-icon.dcf036ed.svg";